import { doc, updateDoc, arrayUnion, arrayRemove, getDoc, runTransaction } from "firebase/firestore";
import { db } from "../firebase";

export async function followUser(currentUserId, targetUserId) {
  try {
    // Validate inputs
    if (!currentUserId || !targetUserId) {
      throw new Error("Invalid user IDs provided");
    }

    // Use transaction for atomic updates
    await runTransaction(db, async (transaction) => {
      const myRef = doc(db, "users", currentUserId);
      const theirRef = doc(db, "users", targetUserId);
      
      // Get current data
      const [myDoc, theirDoc] = await Promise.all([
        transaction.get(myRef),
        transaction.get(theirRef)
      ]);

      // Check if users exist
      if (!myDoc.exists() || !theirDoc.exists()) {
        throw new Error("One or both users not found");
      }

      // Check if already following
      const myFollowing = myDoc.data().following || [];
      if (myFollowing.includes(targetUserId)) {
        throw new Error("Already following this user");
      }

      // Perform updates
      transaction.update(myRef, {
        following: arrayUnion(targetUserId),
      });

      transaction.update(theirRef, {
        followers: arrayUnion(currentUserId),
      });
    });

    return { success: true };
  } catch (error) {
    console.error("Error in followUser:", error);
    return { 
      success: false, 
      error: error.message || "Failed to follow user" 
    };
  }
}

export async function unfollowUser(currentUserId, targetUserId) {
  try {
    // Validate inputs
    if (!currentUserId || !targetUserId) {
      throw new Error("Invalid user IDs provided");
    }

    // Use transaction for atomic updates
    await runTransaction(db, async (transaction) => {
      const myRef = doc(db, "users", currentUserId);
      const theirRef = doc(db, "users", targetUserId);
      
      // Get current data
      const [myDoc, theirDoc] = await Promise.all([
        transaction.get(myRef),
        transaction.get(theirRef)
      ]);

      // Check if users exist
      if (!myDoc.exists() || !theirDoc.exists()) {
        throw new Error("One or both users not found");
      }

      // Check if not currently following
      const myFollowing = myDoc.data().following || [];
      if (!myFollowing.includes(targetUserId)) {
        throw new Error("Not currently following this user");
      }

      // Perform updates
      transaction.update(myRef, {
        following: arrayRemove(targetUserId),
      });

      transaction.update(theirRef, {
        followers: arrayRemove(currentUserId),
      });
    });

    return { success: true };
  } catch (error) {
    console.error("Error in unfollowUser:", error);
    return { 
      success: false, 
      error: error.message || "Failed to unfollow user" 
    };
  }
}